import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import Tooltip from '../../components/Display/Tooltip'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputNumber from '../../components/Inputs/InputNumber'
import InputText from '../../components/Inputs/InputText'
import Switch from '../../components/Inputs/Switch'
import { TextArea } from '../../components/Inputs/TextArea'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { fectchAccounts } from '../../redux/actions/accounts'
import Select from '../../components/Inputs/Select'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'

const OtherConfigurationForm : React.FC<IOtherConfiguration> = ({onCancel, onSubmit, rates, tenantInfo}) => {

  const [windowSize, setWindowSize] = useState(getWindowSize());


  const dispatch = useDispatch()

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
  }

  const [isAutomatic, setIsAutomatic] = useState<boolean>(tenantInfo?.autoRate)

  const accountsRedux = useSelector(
    (state: RootState) => state.acct.accounts
  )
  
  const [accounts, setAccounts] = useState<any>([])

  useEffect(() => {
    dispatch(fectchAccounts())
  }, [])

  useEffect(() => {
    setAccounts(accountsRedux.map((v) => ({ text: v.description || "", value: v.id + '' })))
  }, [accountsRedux])
  
  const getSelectedAccount =  () => {
    return accounts?.find(v => v?.value === tenantInfo?.c2pAccountId)
  }

   const getSelectedAccountPagoMovil=  () => {
    return accounts?.find(v => v?.value === tenantInfo?.pmAccountId)
  }

  const getSelectedZelleAccount =  () => {
    return accounts?.find(v => v?.value === tenantInfo?.zelleAccountId)
  }

  const getSelectedAccountPos = () => {
    return accounts?.find(v => v?.value === tenantInfo?.posAccountId)
  }
 
  const form = useForm({
    defaultValues: {...rates, ...tenantInfo}
  })

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
  ]

  return (
    <Form form={form} onSubmit={onSubmit}>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Otras configuraciones
      </h2>

      <FormItem
        name="whatsappGreeting"
        classes="xl:col-span-12 col-span-12 mb-3"
      >
        <TextArea label='Texto de saludo de whatsapp' placeholder='' />
      </FormItem>

      <FormItem
        name="saleEmailMessage"
        classes="xl:col-span-12 col-span-12 mt-2 mb-3"
        rules={{ required: 'Es necesario este campo' }}
      >
        <InputText small label="Mensaje de correo electrónico al enviar recibo de compra" />
      </FormItem>

      <FormItem
        name="invoiceCode"
        classes="xl:col-span-12 col-span-12 mb-3"
        rules={{
          required: 'Es necesario este campo',
          validate: value =>
            Number(value) >= Number(tenantInfo?.invoiceCode)
              || `El número debe ser mayor o igual a ${tenantInfo?.invoiceCode}`,
        }}
      >
        <InputText small label="Nro siguiente factura" />
      </FormItem>

      <FormItem
        name="invoiceControl"
        classes="xl:col-span-12 col-span-12 mb-3"
        rules={{
          required: 'Es necesario este campo',
          validate: value =>
            Number(value) >= Number(tenantInfo?.invoiceControl)
              || `El número debe ser mayor o igual a ${tenantInfo?.invoiceControl}`,
        }}
      >
        <InputText small label="Nro control" />
      </FormItem>


      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

<div className="col-span-12 mt-3 mb-3">
        <label className="text-sm font-medium">Configuración Pago en línea (C2P)</label>
      </div>


      <FormItem
        name="c2pClientId"
        classes="xl:col-span-12 col-span-12 mb-3"
        rules={{ required: 'Es necesario este campo' }}
      >
        <InputText small label="Rif/CI Titular de la cuenta asociada (Ej: V1234567)" />
      </FormItem>

      <FormItem
            name="c2pAccountId"
            classes="col-span-12 mb-3"
            defaultValue={getSelectedAccount()}
          >
            <SelectOfCategories options={accounts} label="Cuenta Asociada" />
      </FormItem>


      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

<div className="col-span-12 mt-3 mb-3">
        <label className="text-sm font-medium">Configuración Zelle</label>
      </div>

      <FormItem
            name="zelleAccountId"
            classes="col-span-12 mb-3"
            defaultValue={getSelectedZelleAccount()}
          >
            <SelectOfCategories options={accounts} label="Cuenta Asociada de zelle" />
      </FormItem>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className="col-span-12 mt-3 mb-3">
        <label className="text-sm font-medium">Configuración pago móvil</label>
      </div>

      <FormItem
        name="pmClientId"
        classes="xl:col-span-12 col-span-12 mb-3"
        rules={{ required: 'Es necesario este campo' }}
      >
        <InputText small label="Rif/CI Titular de la cuenta asociada (Ej: V1234567)" />
      </FormItem>

      <FormItem
            name="pmAccountId"
            classes="col-span-12 mb-3"
            defaultValue={getSelectedAccountPagoMovil()}
          >
            <SelectOfCategories options={accounts} label="Cuenta Asociada de pago móvil" />
      </FormItem>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className="col-span-12 mt-3 mb-3">
        <label className="text-sm font-medium">Configuración punto de venta</label>
      </div>

      <FormItem
            name="posAccountId"
            classes="col-span-12"
            defaultValue={getSelectedAccountPos()}
          >
            <SelectOfCategories options={accounts} label="Cuenta Asociada de punto de venta" />
      </FormItem>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      {/* <div className="col-span-12 mt-3">
        <label className="text-sm font-medium">Tasas Monedas Extranjeras</label>
      </div>

      <div className="flex col-span-12 mt-3 mb-3">
        <label className='mr-2 font-medium text-left text-primary-900 text-xs mt-1'>Manual</label>
        
        <FormItem
          name="autoRate"
          classes="xl:col-span-12 col-span-12"
        >
          <Switch
            forForm={true}
            onChange={(values) => setIsAutomatic(values)}
          />
        </FormItem>
        <label className='mr-2 font-medium text-left text-primary-900 text-xs mt-1'>Automático (BCV)</label>
      </div> */}

      {!isAutomatic && (
        <div className={`${windowSize.innerWidth < 1200 ? 'col-span-5' : 'col-span-4'} mt-3`}>
          <div className="flex mb-3">
            <label className="mr-2 mt-1 font-medium">USD</label>
            <FormItem
              name="usd"
              classes=""
                rules={{ required: 'Es necesario este campo' }}
            >
              <InputNumber small addDecimals={true} numberOfDecimals={4} />
            </FormItem>
          </div>

          <div className="flex mb-3">
            <label className="mr-3 mt-1 font-medium">COP</label>
            <FormItem
              name="cop"
              classes=""
                rules={{ required: 'Es necesario este campo' }}
            >
              <InputNumber small addDecimals={true} numberOfDecimals={4} />
            </FormItem>
          </div>

          <div className="flex">
            <label className="mr-3 mt-1 font-medium">EUR</label>
            <FormItem
              name="eur"
              classes=""
                rules={{ required: 'Es necesario este campo' }}
            >
              <InputNumber small addDecimals={true} numberOfDecimals={4} />
            </FormItem>
          </div>
        </div>
      )}
{/* 
      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div> */}

      <div className="col-start-4 col-span-9 flex space-x-2 px-1 mt-4 block lg:col-start-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Guardar cambios
        </Button>
      </div>
    </Form>
    // <div>OtherConfigurationForm</div>
  )
}

interface IOtherConfiguration {
    onCancel: () => void
    onSubmit: (values) => void
    rates: any
    tenantInfo: any
}


interface SelectOptions {
  text: string
  value: string
}

export default OtherConfigurationForm